import { useTranslation } from "react-i18next";

interface FeaturedProduct {
  name: string;
  price: string;
  category: string;
  imageUrl: string;
  top?: boolean;
}

const products: FeaturedProduct[] = [
  {
    name: "Air Jordan 4 Retro",
    price: "¥480",
    category: "Shoes",
    top: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Air%20Jordan%204%20Retro%20sneakers%20in%20white%20and%20metallic%20silver%20colorway%20displayed%20on%20a%20pristine%20white%20pedestal%20against%20a%20soft%20gradient%20grey%20background%2C%20professional%20studio%20lighting%20with%20gentle%20rim%20light%20highlighting%20the%20silhouette%2C%20sharp%20detail%20on%20the%20mesh%20panels%20and%20wing%20eyelets%2C%20premium%20sneaker%20product%20photography%2C%20clean%20minimal%20aesthetic%2C%20no%20text&width=600&height=600&seq=kakobuy-feat-v2-aj4&orientation=squarish",
  },
  {
    name: "Stone Island Crewneck",
    price: "¥350",
    category: "Hoodies/Sweaters",
    imageUrl: "https://readdy.ai/api/search-image?query=Stone%20Island%20crewneck%20sweatshirt%20in%20charcoal%20grey%20with%20iconic%20compass%20patch%20on%20left%20sleeve%2C%20folded%20on%20a%20textured%20concrete%20surface%2C%20dramatic%20side%20lighting%20casting%20strong%20shadows%2C%20industrial%20minimal%20aesthetic%2C%20visible%20premium%20cotton%20loopback%20texture%2C%20monochromatic%20moody%20tones%2C%20high%20end%20streetwear%20editorial%20photography%2C%20no%20text&width=600&height=600&seq=kakobuy-feat-v2-stoneisland&orientation=squarish",
  },
  {
    name: "Balenciaga Oversized Tee",
    price: "¥290",
    category: "T-Shirts",
    imageUrl: "https://readdy.ai/api/search-image?query=Balenciaga%20oversized%20t-shirt%20in%20washed%20black%20with%20subtle%20logo%20print%2C%20laid%20flat%20on%20a%20dark%20walnut%20wood%20surface%2C%20moody%20atmospheric%20lighting%20with%20soft%20spotlight%20from%20above%2C%20visible%20cotton%20texture%20and%20relaxed%20drape%2C%20dark%20luxury%20fashion%20editorial%20aesthetic%2C%20rich%20shadow%20detail%2C%20no%20text%2C%20premium%20catalog%20style&width=600&height=600&seq=kakobuy-feat-v2-balenciaga&orientation=squarish",
  },
  {
    name: "Carhartt WIP Cargo Pants",
    price: "¥320",
    category: "Pants/Shorts",
    imageUrl: "https://readdy.ai/api/search-image?query=Carhartt%20WIP%20cargo%20pants%20in%20olive%20green%20military%20style%20neatly%20folded%20on%20a%20raw%20wooden%20workbench%20surface%2C%20natural%20daylight%20from%20a%20workshop%20window%2C%20visible%20durable%20canvas%20fabric%20texture%20and%20pocket%20details%2C%20rugged%20utilitarian%20aesthetic%2C%20earthy%20muted%20green%20tones%2C%20workwear%20editorial%20photography%2C%20no%20text%2C%20authentic%20craftsmanship%20feel&width=600&height=600&seq=kakobuy-feat-v2-carhartt&orientation=squarish",
  },
  {
    name: "New Era 59FIFTY Cap",
    price: "¥180",
    category: "Headwear",
    imageUrl: "https://readdy.ai/api/search-image?query=New%20Era%2059FIFTY%20fitted%20baseball%20cap%20in%20deep%20navy%20blue%20with%20subtle%20gold%20brim%20detail%2C%20placed%20on%20a%20light%20maple%20wooden%20stand%2C%20soft%20studio%20lighting%20from%20the%20front%2C%20visible%20structured%20crown%20shape%20and%20embroidered%20logo%20texture%2C%20clean%20minimal%20product%20photography%2C%20rich%20navy%20and%20warm%20gold%20contrast%2C%20no%20text&width=600&height=600&seq=kakobuy-feat-v2-newera&orientation=squarish",
  },
  {
    name: "Ralph Lauren Crossbody Bag",
    price: "¥260",
    category: "Bags",
    imageUrl: "https://readdy.ai/api/search-image?query=Ralph%20Lauren%20leather%20crossbody%20bag%20in%20rich%20saddle%20brown%20with%20gold%20tone%20hardware%2C%20displayed%20on%20a%20cream%20linen%20fabric%20surface%2C%20warm%20natural%20window%20light%20from%20the%20left%2C%20visible%20fine%20leather%20grain%20and%20stitching%20detail%2C%20classic%20American%20heritage%20aesthetic%2C%20warm%20inviting%20tones%2C%20premium%20accessory%20catalog%20photography%2C%20no%20text&width=600&height=600&seq=kakobuy-feat-v2-rl-bag&orientation=squarish",
  },
];

export default function FeaturedSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-center font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-12">
          {t("featured.title")}
        </h2>

        {/* Horizontal Scroll Container */}
        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-4 snap-x snap-mandatory">
          {products.map((product) => (
            <a
              key={product.name}
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[240px] md:w-[280px] snap-start cursor-pointer group"
              data-product-shop="true"
            >
              <div className="bg-background-50 rounded-2xl border border-background-200/80 overflow-hidden transition-all hover:border-background-300">
                {/* Image */}
                <div className="relative aspect-square overflow-hidden">
                  <img
                    src={product.imageUrl}
                    alt={product.name}
                    title={`${product.name} – Kakobuy Spreadsheet`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  {product.top && (
                    <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-[10px] font-bold rounded-md tracking-wider">
                      {t("featured.top")}
                    </span>
                  )}
                </div>
              </div>
              {/* Info below card */}
              <div className="mt-3 text-center px-2">
                <p className="text-sm font-semibold text-foreground-900 truncate">
                  {product.name}
                </p>
                <p className="text-xs text-foreground-500 mt-0.5">{product.category}</p>
                <p className="text-sm font-bold text-primary-600 mt-1">{product.price}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}